export enum MutationKeys {
  sendCode = 'sendCode',
  login = 'login',
  logout = 'logout',
  addIraUser = 'addIraUser',
  editIraUser = 'editIraUser',
  addEmployer = 'addEmployer',
  editEmployer = 'editEmployer',
  lockIraUser = 'lockIraUser',
  unlockIraUser = 'unlockIraUser',
  confirmation = 'confirmation',
  inviteIraUser = 'inviteIraUser',
  resendInviteIraUser = 'resendInviteIraUser',
  importIraUser = 'importIraUser',
  changePassword = 'changePassword',
  confirmChangingPassword = 'confirmChangingPassword',
  sendForgotPassword = 'sendForgotPassword',
  confirmForgotPassword = 'confirmForgotPassword',
  resetPassword = 'resetPassword',
  checkIndependentIraEmail = 'checkIndependentIraEmail',
  checkIraUserEmail = ' checkIraUserEmail',
  addIndependentIraUser = 'addIndependentIraUser',
  lockIndependentIraUser = 'lockIndependentIraUser',
  unlockIndependentIraUser = 'unlockIndependentIraUser',
  inviteIndependentIraUser = 'inviteIndependentUser',
  resendInviteIndependentIraUser = 'inviteIndependentUser',
  retryAccountCreation = 'retryAccountCreation',
  importContributions = 'importContributions',
  refreshContributions = 'refreshContributions',
  unsubscribeEmail = 'unsubscribeEmail',
  haveAcceptedProfiles = 'haveAcceptedProfiles',
  contributeWalletTransfer = 'contributeWalletTransfer',
}
